import {PriceLevelsModalConfig} from "../types/price-levels-page-modals-config.types";
import {
  DatesCalculationsModalComponent
} from "../components/modals/dates-calculations-modal/dates-calculations-modal.component";

const priceLevelsFieldConfig = {
  dates: { component: DatesCalculationsModalComponent, width: '450px' }
} as const;

export const priceLevelsModalConfig: Record<string, PriceLevelsModalConfig> =
  Object.fromEntries(
    Object.entries(priceLevelsFieldConfig).map(([fieldName, config]) => [
      fieldName,
      {
        ...config,
        fieldName
      }
    ])
  );
